export { default as CargoModel } from './cargo-model';

export { VehicleState as CargoState } from './cargo-model';
